angular
  .module('workflow')

  .controller('WorkflowContributorsController', [
    '$scope',
    '$filter',
    '$timeout',
    'Confirm',
    'Dialog',
    'WorkflowDuplicateContributorsLastRating',

    function(
      $scope,
      $filter,
      $timeout,
      Confirm,
      Dialog,
      WorkflowDuplicateContributorsLastRating
    ) {
      $scope.workflowContributors = [];

      $scope.$watch('workflow', workflow => {
        const workflowContributors = [];
        let { projects } = workflow || {};
        projects = projects || [];

        projects.forEach(project => {
          let { batches } = project || {};
          batches = batches || [];
          batches.forEach(batch => {
            let { tasks } = batch || {};
            tasks = tasks || [];
            tasks.forEach(task => {
              let { contributors: taskContributors } = task || {};
              taskContributors = taskContributors || [];
              taskContributors.forEach(contributor => {
                const {
                  _id,
                  company_name,
                  done,
                  first_name,
                  last_name,
                  lsp,
                  task_status
                } = contributor || {};
                const isApprovedOrConfirmed = [
                  'approved',
                  'confirmed'
                ].includes(task_status);

                if (isApprovedOrConfirmed && done) {
                  const newContributorId = _id;
                  const alreadyExists = workflowContributors.some(
                    ({ _id: contributorId }) =>
                      contributorId.equals(newContributorId)
                  );

                  !alreadyExists &&
                    workflowContributors.push({
                      _id: newContributorId,
                      name: lsp ? company_name : `${first_name} ${last_name}`
                    });
                }
              });
            });
          });
        });

        $scope.workflowContributors = workflowContributors;
      });

      $scope.duplicateLastRatings = () => {
        const { _id } = $scope.workflow || {};
        if (!_id) return;

        new Confirm()
          .info(
            $filter('translate')(
              'workflow.CONTRIBUTORS_DUPLICATE_LAST_RATING_MESSAGE'
            )
          )
          .then(() => new WorkflowDuplicateContributorsLastRating(_id).save())
          .then(response => {
            const { contributors } = response || {};
            let message = $filter('translate')(
              'workflow.CONTRIBUTORS_DUPLICATE_LAST_RATING_SUCCESS'
            );
            message += ' ';
            message += contributors
              .map(contributor => {
                const { company_name, first_name, last_name, lsp } =
                  contributor || {};
                return lsp ? company_name : `${first_name} ${last_name}`;
              })
              .join(', ');
            message += '.';
            $timeout(() => new Dialog().success(message), 250);
          })
          .catch(response => {
            let { contributor, message } = response || {};

            switch (message) {
              case 'NO_CONTRIBUTORS_IN_WORKFLOW_ERROR':
                message = $filter('translate')(
                  'workflow.CONTRIBUTORS_DUPLICATE_LAST_RATING_NO_CONTRIBUTORS_IN_WORKFLOW_ERROR'
                );
                break;
              case 'CONTRIBUTORS_MISMATCH_ERROR':
                message = $filter('translate')(
                  'workflow.CONTRIBUTORS_DUPLICATE_LAST_RATING_CONTRIBUTORS_MISMATCH_ERROR'
                );
                break;
              case 'CONTRIBUTOR_WITHOUT_RATING_ERROR':
                message = $filter('translate')(
                  'workflow.CONTRIBUTORS_DUPLICATE_LAST_RATING_CONTRIBUTOR_WITHOUT_RATING_ERROR'
                );
                const { company_name, first_name, last_name, lsp } =
                  contributor || {};
                message += lsp
                  ? ` ${company_name}`
                  : ` ${first_name} ${last_name}`;
                message += '.';
                break;
              default:
                message = $filter('translate')('error.RECEIVE_ERR');
                break;
            }

            $timeout(() => new Dialog().error(message), 250);
          });
      };
    }
  ]);
